import type { ReactElement } from 'react';

type DoubleHeaderProps = {
  boldSmallTitle?: boolean;
  hero?: boolean;
  largeTitle: ReactElement<HTMLHeadingElement> | string;
  smallTitle: ReactElement<HTMLHeadingElement> | string;
} & ClassNameProp &
  DataTestIdProp;

const DoubleHeader = ({ className = '', smallTitle, largeTitle, hero, boldSmallTitle }: DoubleHeaderProps) => {
  const smallClassNames = `text-h4 ${hero ? '' : 'mb-4'} ${boldSmallTitle ? 'text-black' : 'text-gray-dark'} block`;
  const largeTitleElement = hero ? (
    <h1 className={'text-h1-display row-start-2 block'}>{largeTitle}</h1>
  ) : (
    <div className="text-h2 block">{largeTitle}</div>
  );

  return (
    <div className={className}>
      <div className="grid">
        {typeof largeTitle === 'object' && largeTitle.type === 'h1' ? (
          <>
            {largeTitleElement}
            <div className={smallClassNames}>{smallTitle}</div>
          </>
        ) : (
          <>
            <div className={smallClassNames}>{smallTitle}</div>
            {largeTitleElement}
          </>
        )}
      </div>
    </div>
  );
};

export default DoubleHeader;
